<script>
import useUsuarioStore from "@stores/UsuarioStore.js";
import TabelaDeListaDeDados from "./ListaDeDados/TabelaDeListaDeDados.vue";
import ModalVisualizarDesenho from "./VisualizarDesenho/ModalVisualizarDesenho.vue";
import ModalCriarDesenho from "./CriarDesenho/ModalCriarDesenho.vue";
import ModalEditarDesenho from "./EditarDesenho/ModalEditarDesenho.vue";

export default {
    name: 'DesenhoNumberView',
    components: {
        TabelaDeListaDeDados,
        ModalVisualizarDesenho,
        ModalCriarDesenho,
        ModalEditarDesenho
    },
    data() {
        return {
            usuarioStore: null,
            controlesDesativados: false,
            dado: {},
            visualizandoDado: false,
            editandoDado: false,
            criandoDado: false,
        };
    },
    methods: {
        alteraControlesDesativados(update) {
            this.controlesDesativados = update;
        },
        alteraDado(update = {}) {
            this.dado = update;
        },
        alteraVisualizandoDado(update = {}) {
            this.alteraDado(update?.dado);
            this.visualizandoDado = update.visualizandoDado;
        },
        alteraEditandoDado(update = {}) {
            this.alteraDado(update?.dado);
            this.editandoDado = update.editandoDado;
        },
        alteraCriandoDado(update = {}) {
            this.alteraDado(update?.dado);
            this.criandoDado = update.criandoDado;
        },
        recarregarLista() {
            // Aciona recarregamento da lista após salvar
            if (this.$refs.tabelaDados) {
                this.$refs.tabelaDados.loadDados();
            }
        },
    },
    created() {
        this.usuarioStore = useUsuarioStore();
    }
};
</script>

<template>
    <main
        class="c-main"
        :class="{ 'c-main--disabled': controlesDesativados }"
    >
        <TabelaDeListaDeDados
            ref="tabelaDados"
            :usuarioStore="usuarioStore"
            :visualizandoDado="visualizandoDado"
            :editandoDado="editandoDado"
            :criandoDado="criandoDado"
            :controlesDesativados="controlesDesativados"
            @update:alteraControlesDesativados="alteraControlesDesativados"
            @update:alteraDado="alteraDado"
            @update:alteraVisualizandoDado="alteraVisualizandoDado"
            @update:alteraEditandoDado="alteraEditandoDado"
            @update:alteraCriandoDado="alteraCriandoDado"
        ></TabelaDeListaDeDados>
        
        <ModalVisualizarDesenho
            :usuarioStore="usuarioStore"
            :dado="dado"
            :visualizandoDado="visualizandoDado"
            :controlesDesativados="controlesDesativados"
            @update:alteraDado="alteraDado"
            @update:alteraVisualizandoDado="alteraVisualizandoDado"
        ></ModalVisualizarDesenho>
        
        <ModalCriarDesenho
            :usuarioStore="usuarioStore"
            :dado="dado"
            :criandoDado="criandoDado"
            :controlesDesativados="controlesDesativados"
            @update:alteraDados="recarregarLista"
            @update:alteraDado="alteraDado"
            @update:alteraCriandoDado="alteraCriandoDado"
        ></ModalCriarDesenho>

        <ModalEditarDesenho
            :usuarioStore="usuarioStore"
            :dado="dado"
            :editandoDado="editandoDado"
            :controlesDesativados="controlesDesativados"
            @update:alteraDados="recarregarLista"
            @update:alteraDado="alteraDado"
            @update:alteraEditandoDado="alteraEditandoDado"
        ></ModalEditarDesenho>
    </main>
</template>

<style scoped>
.c-main {
    display: grid;
    gap: 15px;
    height: 100%;
    grid-template-rows: 1fr;
}

.c-main--disabled {
    pointer-events: none;
    user-select: none; 
}
</style>

